import { render, staticRenderFns } from "./AppointmentsTrialsStatistics.vue?vue&type=template&id=d9b3430e"
import script from "./AppointmentsTrialsStatistics.vue?vue&type=script&lang=ts"
export * from "./AppointmentsTrialsStatistics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports